import styled from "@emotion/styled"

const CertificationContentWrap = styled.div`
  display: flex;
  flex-direction: column;
`

export default CertificationContentWrap
